import { formatCurrency, formatPriceLabel } from "./currency";
const descriptorDimensions = (unitType, location, options = {}) => {
  const {
    parens = false,
    showDimensionType = false,
    showSizeSymbol = true,
    spaceAroundSeparator = true
  } = options;
  const isArea = location.settings.unitDimensionDisplay === "area";
  const isSupplementary = options.supplementary ?? (!location.rapidstor.useDescriptorTitle && isArea);
  if (isArea && !isSupplementary && unitType.area != null) {
    const area = formatSize(unitType.area, location, false, !showSizeSymbol);
    return parens ? `(${area})` : area;
  }
  const widthFirst = location.settings.unitDimensionDisplay !== "lengthByWidth";
  const sizeSymbol = showSizeSymbol ? location.rapidstor.sizeSymbol : "";
  const lengthText = `${unitType.length}${sizeSymbol}`;
  const widthText = `${unitType.width}${sizeSymbol}`;
  const [firstText, firstLabel, secondText, secondLabel] = widthFirst ? [widthText, "W", lengthText, "L"] : [lengthText, "L", widthText, "W"];
  const compactSeparator = spaceAroundSeparator ? " x " : "x";
  const separator = showDimensionType ? ` ${firstLabel}/` : compactSeparator;
  const secondSuffix = showDimensionType ? ` ${secondLabel}` : "";
  const dimensions = `${firstText}${separator}${secondText}${secondSuffix}`;
  return parens ? `(${dimensions})` : dimensions;
};
const formatSize = (value, location, noSubscript, noSymbol) => {
  const formatValue = value.toLocaleString(void 0, {
    maximumFractionDigits: 2,
    trailingZeroDisplay: "stripIfInteger"
  });
  if (noSymbol) {
    return formatValue;
  }
  if (noSubscript) {
    return `${formatValue}${location.rapidstor.sizeSymbol}`;
  }
  return `${formatValue}${location.rapidstor.areaSizeSymbol}`;
};
const unitTypeHasDeal = (unitType) => unitType.deal !== void 0;
const unitTypeHasDiscount = (unitType) => unitType.rates.discounted;
const unitTypeDiscountedRate = (unitType) => unitType.deal?.rates.discountedRate ?? unitType.rates.discountedRate;
const unitTypeRate = (unitType) => unitType.rates.rate;
const unitTypeDisplayRate = (unitType) => unitType.deal ? unitTypeDiscountedRate(unitType) : unitTypeRate(unitType);
const unitTypeValueRate = (unitType, location) => formatPriceLabel(formatCurrency(unitTypeRate(unitType), location), location);
const unitTypeFormattedRate = (unitType, location) => formatPriceLabel(formatCurrency(unitTypeDisplayRate(unitType), location), location);
const unitTypeDealSavingsPercentage = (unitType) => {
  if (!unitType.deal?.rates.rate || !unitType.deal?.rates.discountSaved) {
    return "0%";
  }
  const val = unitType.deal.rates.discountSaved / unitType.deal.rates.rate * 100;
  return `${val.toFixed(0)}%`;
};
const unitTypeDealInclusions = (unitType) => unitType.deal ? unitType.deal.descriptions : [];
export {
  descriptorDimensions,
  formatSize,
  unitTypeDealInclusions,
  unitTypeDealSavingsPercentage,
  unitTypeDiscountedRate,
  unitTypeDisplayRate,
  unitTypeFormattedRate,
  unitTypeHasDeal,
  unitTypeHasDiscount,
  unitTypeRate,
  unitTypeValueRate
};
//# sourceMappingURL=UnitTypeDisplay.mjs.map